import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { QueryState } from "@/shared/ui/QueryState";
import { Button, confirm, toast } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import {
  useClassTemplateQuery,
  useDeleteClassTemplate,
  useUpdateClassTemplate,
} from "../api/queries";
import { ClassTemplateForm } from "../ui/ClassTemplateForm";

export function ClassTemplateEditPage() {
  const nav = useNavigate({
    from: "/app/classes/templates/$id/edit",
  });
  const { id } = useParams({ from: "/app/classes/templates/$id/edit" });
  const { data, ...result } = useClassTemplateQuery(id);
  const updateTemplate = useUpdateClassTemplate(id);
  const deleteTemplate = useDeleteClassTemplate();

  const template = data;

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "Template ຄລາດສ໌", to: "/app/classes/templates" },
            { label: "ແກ້ໄຂ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ແກ້ໄຂ Template ຄລາດສ໌
            </h2>
            <p className="text-muted-foreground">
              ປັບປຸງລາຍລະອຽດຂອງ template ຄລາດສ໌.
            </p>
          </div>

          <div className="flex gap-2">
            <Button
              variant="destructive"
              onClick={async () => {
                const ok = await confirm({
                  title: "ລຶບ Template ຄລາດສ໌",
                  description: "ທ່ານແນ່ໃຈບໍ່ວ່າຈະລຶບ template ນີ້?",
                  actionText: "ລຶບ",
                  ActionProps: {
                    variant: "destructive",
                  },
                });
                if (!ok) return;

                try {
                  await toast.promise(deleteTemplate.run(id), {
                    loading: "ກຳລັງລຶບ...",
                    success: () => {
                      nav({ to: "/app/classes/templates" });
                      return "ລຶບ template ສຳເລັດ";
                    },
                    error: "ລຶບ template ລົ້ມເຫຼວ",
                  });
                } catch (error) {
                  // Error handling is done by toast.promise
                }
              }}
            >
              ລຶບ
            </Button>
            <Button
              variant="outline"
              onClick={() =>
                nav({
                  to: "/app/classes/templates/$id",
                  params: { id },
                })
              }
            >
              <ArrowLeftIcon className="size-4" />
              ກັບຄືນ
            </Button>
          </div>
        </div>

        <QueryState
          result={result}
          title="ກຳລັງໂຫຼດ template"
          description="ກຳລັງດຶງລາຍລະອຽດ"
          variant="fullscreen"
        >
          {!template ? null : (
            <div className="mt-6 rounded-xl border bg-card p-6">
              <ClassTemplateForm
                initialValues={{
                  classTypeId: template.classTypeId,
                  levelId: template.levelId,
                  duration: template.duration,
                  description: template.description || "",
                  status: template.status,
                  onlineRegistration: template.onlineRegistration,
                  allowedInstructorIds:
                    template.allowedInstructorIds ?? [],
                }}
                onSubmit={async (vals) => {
                  try {
                    await updateTemplate.mutateAsync(vals);
                    nav({
                      to: "/app/classes/templates/$id",
                      params: { id },
                    });
                  } catch (error) {
                    // Error handling is done by the mutation
                  }
                }}
                submitting={updateTemplate.isPending}
              />
            </div>
          )}
        </QueryState>
      </Main>
    </>
  );
}
